/**
 * Declare Variable
 */
const messages = {
  weekdays: {
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
  },
  times: {
    minute: ':00',
    to: '至',
    '24hr': '24小時營業',
  },
  'toast.promocode.lessThanMinOrderAmount': '尚未達到可使用折扣的最低消費金額(${amt})',
  dialog: {
    'get_quotation_error.title': '報價失敗',
    'get_quotation_error.message': '報價失敗，返回首頁重試',
    'promocode.lessThanMinOrderAmount': '提提你～柯打夠${amt}就有優惠啦～',
    'promocode.addOrder': '+添加柯打',
    'promocode.removePromocode': '移除優惠劵',
    'promocode.removePromocode.message': '是否確定不使用此優惠劵？',
    'promocode.continuePay': '繼續付款',
    confirm_btn: '確定',
    cancel_btn: '取消',
    continue_btn: '繼續',
    'no_available_shipping.title': '查無外送服務',
    'no_available_shipping.message': '很抱歉您所在的地區沒有外送服務。',
    'no_current_location.title': '無法定位目前位置',
    'no_current_location.message': '請確認是否已開啟定位功能，或改以手動輸入地址',
    sold_out_title: '唔好意思，以下您所選的商品已經售完。是否繼續提交訂單以購買其他商品？',
    all_sold_out_title: '唔好意思，您所選的商品已售完。',
    hint: '提示',
    warning: '提示',
    rescan: '請重新掃瞄 QR Code',
    joinbasketErr: '無法加入該桌 請重新掃瞄 QR Code',
    noMerchant: '找不到該餐廳',
    reorder: '重新下單',
    reorder_msg_front: '確定於',
    reorder_msg_back: '號枱開單？',
    reorder_msg_takeaway: '重新下外賣單',
    confirm_clear_order_all: '確定清空柯打？',
    choose_delete_dish_option: '選擇要刪除以下配菜選項及備註',
    remind: '提示',
    go_back: '返回',
    reorder_step: '還沒完成套餐, 確定離開?',
    'dineIn.unavailable.title': '多謝使用點單。',
    'dineIn.unavailable.msg': '抱歉，餐廳現時暫停堂食服務。請稍後再試或聯絡餐廳: 電話 +852 ',
    'takeaway.unavailable.title': '多謝使用點單。',
    'takeaway.unavailable.msg': '抱歉，餐廳現時暫停外賣服務。請稍後再試或聯絡餐廳: 電話 +852 ',
    'delivery.unavailable.title': '多謝使用點單。',
    'delivery.unavailable.msg': '抱歉，餐廳現時暫停送餐服務。請稍後再試',
    option_div_none: '無',
    scan_result: '掃描結果',
    rescan_btn: '再次掃描',
    pickup_code: '取餐碼',
    pickup_success: '取餐成功',
    pickup_failed: '取餐失敗',
    pickup_error_status: {
      402: '驗證碼錯誤',
      403: '找不到訂單',
      500: '已領餐',
    },
    camera_failure: '相機啟動失敗',
    invalid_card_number_title: '信用卡輸入錯誤',
    invalid_card_number_message: '提醒您！本活動僅限使用中國建設銀行(亞洲) VISA/Master 信用卡。',
    hotel_passcode: '請輸入四位數字密碼:',
    hotel_passcode_error: '密碼錯誤',
  },
  history: {
    order_recent: '最近柯打',
    order: '柯打',
    table_no: '號枱',
    room_no: '號房',
    order_paid: '付款完成',
  },
  checkout: {
    especial_title: '要求喜好',
    today: '今天',
    total_of_front: '總計 (共',
    'total_of_front.takeaway': '共',
    total_of_back: '個菜色)',
    total_of_back2: '個項目)',
    'total_of_back.takeaway': '個菜色)',
    total_choose_front: '共選',
    total_choose_back: '客',
    total_choose_back2: '項目',
    empty_order: '你未落柯打 即刻按左上角點單啦',
    clear_order_all: '全部清空',
    remark: '你可於此輸入特別需求',
    surcharge: '附加費',
    discount: '折扣',
    serial: '單號',
    code: '取餐編號',
    status: '狀態',
    'status.pending': '用餐中',
    'status.paid': '已付款',
    'status.ready': '未取餐',
    'status.completed': '已取餐',
    'status.delivered': '已送達',
    'status.cancelled': '已取消',
    'method.visa': 'Visa卡',
    'method.unionpay': 'UnionPay卡',
    'method.master': 'Master卡',
    'method.unknown': 'Unknown',
    'method.ae': 'American Express卡',
    'method.alipay': '支付寶',
    'method.wechat': '微信支付',
    'method.wechatpay': '微信支付',
    'method.octopus': '八達通',
    'method.bypass': 'bypass',
    'method.cash': '收銀處付款',
    'method.card': '信用卡',
    'method.creditsales': '賒數',
    'method.wechat.scan_to_pay': '請打開微信掃瞄二維碼付款',
    'hand.up.waiter': '侍應',
    'hand.up.pay': '付款',
    reorder: '重新下單',
    'waiting.waiter.toast': '已要求侍應 請耐心等候',
    'waiting.pay.toast': '已要求付款 請耐心等候',
    'pay.by.cash.confirm': '確定到店以現金付款？',
    'item.remark': '備註',
  },
  summary: {
    'restaurant.info': '餐廳資料',
    'shop.info': '店舖資料',
    'restaurant.info.name': '名稱',
    'restaurant.info.address': '地址',
    'restaurant.info.delivery.address': '送餐地址',
    'restaurant.info.tel': '電話',
    time: '時間',
    please_select: '請選擇',
    deliveryType: '配送方式',
    'deliveryType.takeaway': '外賣自取',
    'deliveryType.delivery': '外送',
    'deliveryType.shop': '網店',
    'deliveryType.storeDelivery': '餐廳外送',
    name: '姓名',
    date: '日期',
    tel_placeholder: '聯絡電話',
    'undetermined.price': '時價',
    'remark.placeholder': '輸入特別要求',
    floorRoom: '樓層或房號',
    companyBuilding: '公司或大樓名稱',
    required: '(此欄必須填寫)',
  },
  changeTable: {
    inactiveTable: '空閒座位',
  },
  footer: {
    processing: '處理中',
    'takeaway.confirm.pay': '確定付款',
    'total_of_back.takeaway': '個菜色)',
    'total_of_front.takeaway': '總計 (共',
    checkout_confirm_booking: '確認訂枱',
    checkout_confirm: '確認落單',
    checkout_immediate: '即刻落單',
    checkout_submiting: '正在提交',
    checkout: '落單',
    choose: '揀',
    change_table: '轉枱',
    choose_table: '揀枱',
    choosing: '點緊',
    confirm: '確認',
    dish_no: '個菜式',
    item_no: '個項目',
    no_of: '第',
    remaining_prefix: '尚餘',
    remaining_suffix: '份',
    set_no: '份',
    step: '步',
    still_not_choose_back: '等',
    still_not_choose_front: '還未揀',
    switch_table: '轉枱',
    table_no: '{value} 號枱',
    room_no: '{value} 號房',
    takeaway_no: '外賣',
    total_of_back: '個菜色',
    total_of_back2: '個項目',
    total_of_front: '共',
    waiting_for_payment: '等待付款',
    other_restaurants: '其他餐廳',
    waiting_for_table: '請再次掃描店內QRCode以確認落單',
    skipAll: '跳過全部',
  },
  confirmation: {
    success: '成功提交',
    success_submit_order: '你已經成功落單',
    success_description: '食物制作需時, 請你耐心等侯',
    success_hotel_description: '請你耐心等侯',
    continue_order: '繼續點單',
    view_history: '查看記錄',
    go_back: '返回',
  },
  rightSideBar: {
    order_history: '柯打記錄',
    menus: '菜單',
  },
  categoryDetailList: {
    promo: '推薦',
    no_category_list: '抱歉， 沒有此分類。',
  },
  navBarLite: {
    complete: '完成',
    edit: '編輯',
    'me.only': '我的',
    all: '全部',
  },
  navBarSwiper: {
    hot_sale: '本店推薦',
    all_category: '所有分類',
  },
  stepper: {
    confirm_submit: '確認提交',
    sold_out: '售罄',
    back: '返回',
  },
  about: {
    address: '地址',
    phone: '電話號碼',
    opening: '營業時間',
  },
  error: {
    general: '發生錯誤，請重試',
    'submit too fast': 'You are trying to submit too fast. Try again in {batchInterval}',
    'invalid.timeslot': '截單時間已過',
    'invalid.amount_too_small': '訂單金額未滿最低消費 ${minAmount}',
    'cutoff order': '截單時間已過',
    stripe: {
      amount_too_small: '賬單金額不足$4,請返回餐牌柯打更多項目',
      authentication_required: '請跟信用卡中心聯絡',
      card_decline_rate_limit_exceeded: '由於多次授權被拒絕，請與信用卡中心聯絡',
      card_declined: '信用卡授權被拒絕,請與信用卡中心聯絡',
      charge_already_captured: '在處理信用卡時發生錯誤(錯誤代碼102)',
      charge_already_refunded: '在處理信用卡時發生錯誤(錯誤代碼103)',
      charge_disputed: '在處理信用卡時發生錯誤(錯誤代碼104)',
      charge_exceeds_source_limit: '在處理信用卡時發生錯誤(錯誤代碼105)',
      charge_expired_for_capture: '餐廳必須於七天內完成訂單，否則有關款項未能收取 (Merchant)',
      charge_invalid_parameter: '在處理信用卡時發生錯誤(錯誤代碼106)',
      customer_max_payment_methods: '信用卡正處理多宗訂單,請使用其他信用卡進行付款',
      customer_max_subscriptions: '在處理信用卡時發生錯誤(錯誤代碼107)',
      expired_card: '此信用卡已過期,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      incorrect_cvc: '信用卡CVC錯誤,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      incorrect_number: '信用卡號碼錯誤,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      incorrect_zip: '信用卡驗證碼不被接納',
      instant_payouts_unsupported: '此信用卡不支持網上付款,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      intent_invalid_state: '在處理信用卡時發生錯誤(錯誤代碼108)',
      intent_verification_method_missing: '在處理信用卡時發生錯誤(錯誤代碼109)',
      invalid_card_type: '不支持此信用卡,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      invalid_charge_amount: '賬單金額不足$4,請返回餐牌柯打更多項目',
      invalid_cvc: '信用卡CVC錯誤,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      invalid_expiry_month: '信用卡月份錯誤,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      invalid_expiry_year: '信用卡年份錯誤,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      invalid_number: '信用卡號碼錯誤,請使用其他信用卡進行付款或請與信用卡中心聯絡',
      order_creation_failed: '在處理信用卡時發生錯誤(錯誤代碼110),請重試',
      order_required_settings: '信用卡資料錯誤(錯誤代碼112),請重試',
      order_upstream_timeout: 'time out problem，請重試',
      processing_error: '在處理信用卡時發生錯誤',
      token_already_used: '在處理信用卡時發生錯誤(錯誤代碼113),請重試',
      token_in_use: '在處理信用卡時發生錯誤(錯誤代碼114),請重試',
      transfers_not_allowed: '在處理信用卡時發生錯誤(錯誤代碼115),請重試',
      upstream_order_creation_failed: '在處理信用卡時發生錯誤(錯誤代碼116),請重試',
    },
  },
  lang: {
    en: 'English',
    zh: '繁體中文',
  },
  delivery: {
    // 'status.pending': '等待商家接單...',
    // 'status.confirmed': '商家已接單，餐點正在製作中...',
    // 'status.ready': '已出餐，步兵正在前往領取',
    // 'status.cancelled': '商家已取消',
    // 'status.completed': '步兵已取餐，正在送餐',
    // 'status.delivered': '已送達',
    'deliverystatus.enroute': '外送夥伴正在前往你的位置，請留意電話！外送查詢熱線: 5267 1016',
    'deliverystatus.delivered': '已送達！謝謝！',

    redbar: '- "免運費"外送服務適用於12:30pm-2:00pm',
    redbar2: '- 每天11:20am截單,其他時段歡迎外賣自取',
    redbar3: '- 運送只限附近之指定醫院及診所',
    redbar4: '- 醫護優惠只限醫護人員，如非醫護人員，餐廳有權索回差價',
  },
  storedelivery: {
    'status.completed': '餐廳已出餐，好快有得食',
  },
  shop: {
    'status.completed': '商店已出貨',
  },
  takeaway: {
    'summary.collapsed.header': '總計',
    'toggle.button.title': '顯 示',
    'toggle.button.title.hide': '隱 藏',
    'summary.total.number': '份 餐單',
    'summary.total.number.shop': '客',
    'summary.cardholder_placeholder': '持卡人姓名',
    'summary.cardnum_placeholder': '信用卡號碼',
    'summary.card_expiration_placeholder': '月 / 年',
    'summary.ccv_placeholder': '卡安全碼',
    'status.pending': '柯打已經傳送到餐廳，等候餐廳確認中',
    'status.confirmed': '餐點正在製作中，好快有得食',
    'status.ready': '已出餐，請前往領取',
    'status.cancelled': '商家已取消，如有任何查詢，請致電點單客戶專線：5267 1016',
    'status.completed': '已取餐，再次多謝你使用點單',
    'status.delivered': '已送達，再次多謝你使用點單',
    'summary.restaurant.code.header': '取餐號碼',
    'summary.pickup.time': '取餐時間',
    'summary.pickup.status': '狀態',
    cancel_reason: '取消原因',
    'cancel.missing': '未能提供菜色',
    'cancel.busy': '太繁忙',
    'cancel.rejected': '已取消',
    'cancel.closed': '非營業時間',
    'cancel.other': '其他',
    'summary.pay.with.recent.method': '使用上次付款方法',
    'payment.method.cash': '現金',
    'payment.method.cashier': '現場付款',
    'payment.method.creditCard': '信用卡',
    'payment.method.wechatPay': '微信支付',
    'payment.method.applePay': 'Apple Pay',
    'payment.method.googlePay': 'Google Pay',
    'payment.method.comingsoon': '即將推出',
    'order.promo.code': '優惠碼',
    'order.promo.memberpromo': '會員優惠',
    'order.promo.code.submit': '兌換',
    'order.promo.code.cancel': '取消',
    'order.promo.code.invalid': '優惠碼不正確 請重新輸入',
    'request.delivery': '需要送餐',
    reorderAfterOrderComplete: '訂單完成後可重新下單',
    reorder: '重新落單',
    rechoose: '重新選擇',
    needTableware: '是否需要餐具？',
  },
  shipping: {
    please_select_date: '請先選擇日期',
    please_select_period: '請先選擇時段',
    please_select_shipping: '請選擇外送服務',
    no_available_shipping: '沒有可用的外送服務',
    shipping_service: '外送服務',
    minimun_charge: '最低消費',
    shipping_fee: '運費',
    free_shipping: '免運費',
    freight_collect: '運費到付',
    please_fill_address: '請輸入地址',
    no_options_message: '沒有符合的選項',
  },
  bottomsheet: {
    'max.prefix': '(最多',
    'min.prefix': '(最少',
    suffix: '項)',
    'max.min.and': '至',
  },
  carousel: {
    'set.btn': '點套餐',
    'price.attr': '起',
  },
  required: '需要',
  notRequired: '不需要',
  searchText: '搜尋商品名稱或代碼',
  soldOutSoon: '即將售罄',
  tnc: {
    line1: '確認訂單即表示同意所有',
    linkText: '條款及細則',
    line1AfterLink: '，及明白服務一經確認不可取消',
    line2: '',
  },
  merchantAccount: '餐廳帳號',
  account: '帳號',
  password: '密碼',
  login: '登入',
  otherTableGroups: '其他枱號',
  'servicenotavailable.timeslot': '此時段暫不提供此服務',

  directory: {
    opening: {
      title: '外賣自取 / 外送時段',
      subtitle: {
        takeaway: '自取時段',
        delivery: '外送時段',
      },
    },
    dateTimePicker: {
      title: {
        takeaway: '選擇自取時間',
        delivery: '選擇外送時間',
      },
      selectDate: {
        takeaway: '自取日期',
        delivery: '外送日期',
      },
      selectTime: {
        takeaway: '自取時間',
        delivery: '預計送達時間(視乎地區及交通情況而受影響*)',
      },
      submit: '立即揀選美食',
    },
    selector: {
      immediate: '即時',
      around45minDeliver: '大約45分鐘送到*',
      around: '大約',
      pickupAfter: '大約',
      minDeliver: '分鐘送到*',
      minPickup: '分鐘後取餐*',
      noAvailableShipping: '無適用外送服務',
    },
    bottomNavigation: {
      takeaway: '自取',
      takeawayDisable: ' － 暫未提供',
      delivery: '外送',
      shop: '網店',
      map: '地圖',
    },
  },

  waiter: {
    numberPad: {
      clear: '清除',
    },
  },
  loading: '載入中',
  nextStep: '下一步',
  prevStep: '上一步',
  updateMessage: '即將自動更新',
  update: '更新',
  minus: '減',

  wechatConfirmation: {
    message: '請確認微信支付是否已完成',
    paid: '已完成支付',
    error: '支付遇到問題，重新支付',
    loading: '支付確認中',
  },
  bookmark: {
    androidAlert: '下載點單餐廳網頁到主畫面',
    androidDownload: '下載',
    iphoneAlertTitle: '把點單餐廳網頁加到主頁，請使用safari瀏覽器',
    iphoneAlert1: '按下',
    iphoneAlert2: "按鈕，然後按 '加至主頁面'",
  },
  setItemPrice: {
    title: '設定項目價格',
    price: '輸入金額',
    enter: '確定',
    cancel: '取消',
  },
}

/**
 * Export
 */
export default messages



// WEBPACK FOOTER //
// ./src/intl/locales/zh_HK.js